import makeAction from "./../../libs/actions";

export const fetchPosts = makeAction("posts/FETCH_POSTS");
export const fetchPostBySlug = makeAction("posts/FETCH_POST_BY_SLUG");
